import { Activity, Settings, BarChart3, Sliders, Radio, FileText, Layers, Landmark, MousePointerClick, Wifi, LucideIcon } from 'lucide-react';

// Single source of truth for the sidebar — previously hand-duplicated byte-for-byte between
// MainLayout.tsx and Dashboard.tsx (Dashboard.tsx built its own entire shell instead of using
// MainLayout), which meant any sidebar change had to be made twice or it silently drifted.
// Dashboard.tsx now just renders <MainLayout>, so this is the only place this list lives.
export interface MenuItem {
  icon: LucideIcon;
  label: string;
  path: string;
  color?: string;
}

export const menuItems: MenuItem[] = [
  { icon: BarChart3, label: 'DASHBOARD', path: '/dashboard' },
  { icon: Activity, label: 'FILTER SETTINGS', path: '/filter-settings' },
  { icon: Radio, label: 'LIVE PAGE', path: '/live-page' },
  { icon: Sliders, label: 'NSE ENTRY/EXIT', path: '/entry-exit', color: '#1a6b3c' },
  { icon: FileText, label: 'NSE ORDERS', path: '/orders', color: '#1a6b3c' },
  { icon: Sliders, label: 'BSE ENTRY/EXIT', path: '/bse/entry-exit', color: '#8b0000' },
  { icon: FileText, label: 'BSE ORDERS', path: '/bse/orders', color: '#8b0000' },
  { icon: MousePointerClick, label: 'MANUAL SPREAD', path: '/manual-spread', color: '#374151' },
  { icon: Sliders, label: 'NY SPREAD', path: '/ny-spread', color: '#0d6efd' },
  { icon: FileText, label: 'NY SPREAD ORDERS', path: '/ny-spread/orders', color: '#0d6efd' },
  { icon: Sliders, label: 'SX SPREAD', path: '/sx-spread', color: '#fd7e14' },
  { icon: FileText, label: 'SX SPREAD ORDERS', path: '/sx-spread/orders', color: '#fd7e14' },
  { icon: Layers, label: 'OPTION SELLING', path: '/option-selling', color: '#6f42c1' },
  { icon: FileText, label: 'OPTION SELLING ORDERS', path: '/option-selling/orders', color: '#6f42c1' },
  { icon: Landmark, label: 'CASH MARKET', path: '/cash-market', color: '#0d9488' },
  { icon: Sliders, label: 'NIFTY/SENSEX BUYING', path: '/nifty-buying', color: '#ca8a04' },
  { icon: FileText, label: 'NIFTY/SENSEX ORDERS', path: '/nifty-buying/orders', color: '#ca8a04' },
  { icon: Wifi, label: 'BROKER MANAGEMENT', path: '/broker-management' },
  { icon: Settings, label: 'SETTINGS', path: '/settings' },
];

// SETTINGS can never be hidden — hiding it strands the user with no way back in to undo the
// hide. Dashboard is hideable (client's explicit ask). Enforced again server-side.
export const ALWAYS_VISIBLE_PATHS = ['/settings'];
